<template>
  <div class="new-help-list">
    <mt-header fixed :title="titleText" class="title1">
      <mt-button slot="left" icon="back" @click="backClickHandler">返回</mt-button>
    </mt-header>
    <!-- banner -->
    <div class="nhl-banner">
      <img :src="helpBannerList" />
    </div>
    <!-- 标题 -->
    <div class="nhl-title">常见问题</div>
    <!-- 九宫格 -->
    <div class="nhl-items clearfix">
      <div class="item" v-for="(item, index) in titleList" :key="index" @click="handleItemClickEvent(item.id)">
        <div class="item-img">
          <img :src="item.imgUrl" />
        </div>
        <div class="item-name">{{ item.title }}</div>
      </div>
    </div>
    <!-- 在线客服 -->
    <div class="nhl-service clearfix" @click="handleCustomerClickEvent">
      <div class="service-img">
        <svg-icon :icon-class="iconSvgPath" class-name="cur-icon service"></svg-icon>
      </div>
      <div class="service-text">
        <div class="service-name">在线客服</div>
        <div class="service-msg">1对1专门解答</div>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_MOBILE */
/* global PUBLIC_HELP_PLUS_TITLE */
/* global PUBLIC_PRODUCT */
/* global PUBLIC_SYSTEM_FLAG */
/* global PUBLIC_YSF_GROUPID */
/* global ysf */

import { Indicator } from 'mint-ui';
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'NewHelpList',
  props: ['titleText'],
  comments: { SvgIcon },
  data() {
    return {
      isSdkReady: false,
      iconSvgPath: 'help_service',
      customerMobile: PUBLIC_MOBILE,
      titleList: PUBLIC_HELP_PLUS_TITLE,
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
    };
  },
  computed: {
    helpBannerList() {
      switch (this.product) {
        case 'yft':
        case 'yftzs':
          return require('@/assets/help_banner@3x.png');
        case 'cxyf':
        case 'cxyfzs':
          return require('@/assets/help_banner@3x.png');
        case 'cxpro':
        case 'cxplus':
        case 'cxpluszs':
          return require('@/assets/help_banner@3x.png');
        case 'hfplus':
        case 'hfpluszs':
          return require('@/assets/help_banner@3x.png');
        case 'xhgj':
          return require('@/assets/help_banner@3x.png');
        default:
          return require('@/assets/help_banner@3x.png');
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setHelpTitleList();
      // 初始化SDK
      ysf(
        'onready',
        function () {
          this.isSdkReady = true;
          const p_uid = this.getOKUserID();
          const p_mobile = this.getOkMobileStr();
          let p_name = '';
          switch (this.product) {
            case 'yft':
              p_name = '易付通用户';
              break;
            case 'yftzs':
              p_name = '易付通助手用户';
              break;
            case 'cxyf':
              p_name = '恒付用户';
              break;
            case 'cxyfzs':
              p_name = '恒信通用户';
              break;
            case 'cxpro':
            case 'cxplus':
              p_name = '诚享PLUS用户';
              break;
            case 'cxpluszs': // 诚享PLUS助手
              p_name = '诚享PLUS助手用户';
              break;
            case 'hfplus':
              p_name = '恒付PLUS用户';
              break;
            case 'hfpluszs': // 诚享PLUS助手
              p_name = '恒付PLUS助手用户';
              break;
            case 'xhgj':
              p_name = '小恒管家用户';
              break;
            case 'cxzf':
            case 'cxzfzs':
              p_name = '诚享支付用户';
              break;
            case 'cxzfpos':
            case 'cxzfposzs':
              p_name = '小微碰pos用户';
              break;
            case 'xxwp':
              p_name = '新小微碰用户';
              break;
            default:
              p_name = '易付通用户';
              break;
          }
          // 上报用户信息
          ysf('config', {
            uid: p_uid,
            mobile: p_mobile,
            name: `${p_name}(${p_mobile})`,
            groupid: PUBLIC_YSF_GROUPID,
          });
        }.bind(this)
      );
    });
  },
  methods: {
    backClickHandler() {
      window.location.href = 'protocol://android';
    },
    handleCustomerClickEvent() {
      // 打开窗口
      if (this.isSdkReady) {
        Indicator.open('窗口加载中...');
        setTimeout(() => {
          Indicator.close();
          ysf('open');
        }, 1800);
      } else {
        alert('窗口加载失败，请点击按钮重新加载');
      }
    },
    getOKUserID() {
      let result = '';
      let uid = '';
      // 生成uid
      switch (this.product) {
        case 'yft':
        case 'cxyf':
        case 'cxpro':
        case 'cxplus':
        case 'hfplus':
          if (PUBLIC_SYSTEM_FLAG === 'android' || PUBLIC_SYSTEM_FLAG === '') uid = 'azd' + this.customerMobile;
          else if (PUBLIC_SYSTEM_FLAG === 'ios') uid = 'izd' + this.customerMobile;
          else uid = 'azd' + this.customerMobile;
          break;
        case 'yftzs':
        case 'cxyfzs':
        case 'cxpluszs':
        case 'hfpluszs':
        case 'xhgj':
          if (PUBLIC_SYSTEM_FLAG === 'android' || PUBLIC_SYSTEM_FLAG === '') uid = 'azs' + this.customerMobile;
          else if (PUBLIC_SYSTEM_FLAG === 'ios') uid = 'izs' + this.customerMobile;
          else uid = 'azs' + this.customerMobile;
          break;
        default:
          if (PUBLIC_SYSTEM_FLAG === 'android' || PUBLIC_SYSTEM_FLAG === '') uid = 'azd' + this.customerMobile;
          else if (PUBLIC_SYSTEM_FLAG === 'ios') uid = 'izd' + this.customerMobile;
          else uid = 'azd' + this.customerMobile;
          break;
      }
      // 生成随机数
      const max = 999999999999;
      const min = 100000000000;
      const number = Math.floor(Math.random() * (max - min + 1) + min);
      // 判断如果存在手机号，用uid，反正用随机数
      result = this.customerMobile ? uid : number;
      return result;
    },
    getOkMobileStr() {
      let result = '';
      // 生成日期字符串
      const nowDate = new Date();
      const yy = String(nowDate.getFullYear());
      const mm = String(nowDate.getMonth() + 1).padStart(2, '0');
      const dd = String(nowDate.getDate()).padStart(2, '0');
      const hh = String(nowDate.getHours()).padStart(2, '0');
      const ms = String(nowDate.getMinutes()).padStart(2, '0');
      const ss = String(nowDate.getSeconds()).padStart(2, '0');
      const tmpMobile = yy + mm + dd + hh + ms + ss;
      // 判断如果存在手机号，做脱敏处理 反之则返回年月日时分秒的临时字符串
      if (this.customerMobile) {
        result = `${this.customerMobile.substr(0, 3)}****${this.customerMobile.substr(-4)}`;
      } else {
        result = tmpMobile;
      }
      return result;
    },
    handleItemClickEvent(id) {
      this.$router.push({ path: '/newhelpdetail', query: { id } });
    },
    setHelpTitleList() {
      switch (this.product) {
        case 'yft':
        case 'yftzs':
          this.titleList[0].imgUrl = require('@/assets/help_register_y@3x.png');
          this.titleList[1].imgUrl = require('@/assets/help_authentication_y@3x.png');
          this.titleList[2].imgUrl = require('@/assets/help_bankcard_y@3x.png');
          this.titleList[3].imgUrl = require('@/assets/help_other_y@3x.png');
          break;
        case 'cxyf':
        case 'cxyfzs':
          this.titleList[0].imgUrl = require('@/assets/help_register_hf@3x.png');
          this.titleList[1].imgUrl = require('@/assets/help_authentication_hf@3x.png');
          this.titleList[2].imgUrl = require('@/assets/help_bankcard_hf@3x.png');
          this.titleList[3].imgUrl = require('@/assets/help_other_hf@3x.png');
          break;
        case 'cxpro':
        case 'cxplus':
        case 'cxpluszs':
          this.titleList[0].imgUrl = require('@/assets/help_register@3x.png');
          this.titleList[1].imgUrl = require('@/assets/help_authentication@3x.png');
          this.titleList[2].imgUrl = require('@/assets/help_bankcard@3x.png');
          this.titleList[3].imgUrl = require('@/assets/help_other@3x.png');
          break;
        case 'hfplus':
        case 'hfpluszs':
          this.titleList[0].imgUrl = require('@/assets/help_register_hfp@3x.png');
          this.titleList[1].imgUrl = require('@/assets/help_authentication_hfp@3x.png');
          this.titleList[2].imgUrl = require('@/assets/help_bankcard_hfp@3x.png');
          this.titleList[3].imgUrl = require('@/assets/help_other_hfp@3x.png');
          break;
        case 'xhgj':
          this.titleList[0].imgUrl = require('@/assets/help_register_x@3x.png');
          this.titleList[1].imgUrl = require('@/assets/help_authentication_x@3x.png');
          this.titleList[2].imgUrl = require('@/assets/help_bankcard_x@3x.png');
          this.titleList[3].imgUrl = require('@/assets/help_other_x@3x.png');
          break;
        default:
          this.titleList[0].imgUrl = require('@/assets/help_register_y@3x.png');
          this.titleList[1].imgUrl = require('@/assets/help_authentication_y@3x.png');
          this.titleList[2].imgUrl = require('@/assets/help_bankcard_y@3x.png');
          this.titleList[3].imgUrl = require('@/assets/help_other_y@3x.png');
          break;
      }
      this.$forceUpdate();
    },
  },
};
</script>
